import { graphql } from 'gatsby';
import { Form } from '@ahaui/react';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import inputText from 'src/examples/Form/inputText';
import inputPassword from 'src/examples/Form/inputPassword';
import inputEmail from 'src/examples/Form/inputEmail';
import inputNumber from 'src/examples/Form/inputNumber';
import inputTextArea from 'src/examples/Form/inputTextArea';
import inputSelect from 'src/examples/Form/inputSelect';
import inputMultiSelect from 'src/examples/Form/inputMultiSelect';
import inputFile from 'src/examples/Form/inputFile';
import inputNormal from 'src/examples/Form/inputNormal';
import inputDisabled from 'src/examples/Form/inputDisabled';
import inputReadOnly from 'src/examples/Form/inputReadOnly';
import inputValid from 'src/examples/Form/inputValid';
import inputInvalid from 'src/examples/Form/inputInvalid';
import inputSizeSmall from 'src/examples/Form/inputSizeSmall';
import inputSizeNormal from 'src/examples/Form/inputSizeNormal';
import inputSizeLarge from 'src/examples/Form/inputSizeLarge';
import groupBasic from 'src/examples/Form/groupBasic';
import group2Basic from 'src/examples/Form/groupBasic-2';
import group3Basic from 'src/examples/Form/groupBasic-3';
import groupMultipleAddon from 'src/examples/Form/groupMultipleAddon';
import groupMultipleInput from 'src/examples/Form/groupMultipleInput';
import groupSize from 'src/examples/Form/groupSize';
import groupButtonAddon from 'src/examples/Form/groupButtonAddon';
import group2ButtonAddon from 'src/examples/Form/groupButtonAddon-2';
import group3ButtonAddon from 'src/examples/Form/groupButtonAddon-3';
import group4ButtonAddon from 'src/examples/Form/groupButtonAddon-4';
import group5ButtonAddon from 'src/examples/Form/groupButtonAddon-5';
import * as React from 'react';
export default {
  graphql,
  Form,
  ComponentApi,
  CodeView,
  inputText,
  inputPassword,
  inputEmail,
  inputNumber,
  inputTextArea,
  inputSelect,
  inputMultiSelect,
  inputFile,
  inputNormal,
  inputDisabled,
  inputReadOnly,
  inputValid,
  inputInvalid,
  inputSizeSmall,
  inputSizeNormal,
  inputSizeLarge,
  groupBasic,
  group2Basic,
  group3Basic,
  groupMultipleAddon,
  groupMultipleInput,
  groupSize,
  groupButtonAddon,
  group2ButtonAddon,
  group3ButtonAddon,
  group4ButtonAddon,
  group5ButtonAddon,
  React
};